import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { ApplicationConfig } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeHelper {
  private deviceTypes;
  private data: Observable<any>;
  private unsubscribe: Subject<void> = new Subject();

  constructor(private http: HttpClient, private config: ApplicationConfig) {}

  deviceDetection() {
    if (this.deviceTypes) {
      return of(this.deviceTypes);
    } else if (this.data) {
      return this.data;
    } else {
      const retries: number = Number.parseInt(this.config.get('APP_RETRIES'));
      this.data = this.http
        .get<any>(
          `//${window.location.host}/${this.config.get(
            'APP_CONTEXT_ROOT'
          )}${this.config.get('APP_DEVICE_TYPE_URL')}`
        )
        .pipe(
          map((res) => {
            this.deviceTypes = res;
            return res;
          }),
          share()
        );
      return this.data;
    }
  }
}
